import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Spin,
  DatePicker,
  Form,
  notification,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import IconWithTextCard from "./Chartjs/PosHomeWidget";
import RequestHandler from "../../util/RequestHandler";
import PosBarChart from "./Chartjs/PosBarChart";
import PosGroupColumnChart from "./Chartjs/PosGroupColumnChart";
import PosMultiLinePlotChart from "./Chartjs/PosMultiLinePlotChart";
import moment from "moment";

function PosReports() {
  const [monthlyPosVolumeData, setMonthlyPosVolumeData] = useState("");
  const [monthlyBankBasedTotalAmounts, setMonthlyBankBasedTotalAmounts] =
    useState([]);
  const [monthlyBankCommissionAmount, setMonthlyBankCommissionAmount] =
    useState([]);
  const [
    monthlyBankTotalCommissionAmount,
    setMonthlyBankTotalCommissionAmount,
  ] = useState([]);
  const [mostMonthlyUsedPos, setMostMonthlyUsedPos] = useState([]);
  const [leastMonthlyUsedPos, setLeastMonthlyUsedPos] = useState([]);
  const [forwardValueDateAmount, setForwardValueDateAmount] = useState([]);


  const [bankBasedVolumeDate, setBankBasedVolumeDate] = useState( {
    startMonth: moment().add(-5, "month"),
    endMonth: moment()
  });

  const [dateRange, setDateRange] = useState({
    startValorDate: moment(),
    endValorDate: moment().add(7, 'days'),
    datePicture: true,
  });

  const [loading, setLoading] = useState(false);
  const [loadingMonthlyBankAmount, setLoadingMonthlyBankAmount] =
    useState(true);
  const [loadingMostMonthlyUsedPos, setloadingMostMonthlyUsedPos] =
    useState(true);
  const [loadingleastMonthlyUsedPos, setloadingleastMonthlyUsedPos] =
    useState(true);
  const [isLoadingForwardValueDate, setIsLoadingForwardValueDate] =
    useState(true);
  const [
    loadingmonthlyBankBasedTotalAmountsReport,
    setloadingmonthlyBankBasedTotalAmountsReport,
  ] = useState(true);


  useEffect(() => {
    getMonthlyPosVolumeReport();
    usedPosReport();
    monthlyBankCommissionTotalsReport();
  }, [])


  useEffect(() => {
    if(dateRange.datePicture) {
      forwardValueDateAmountReport()
    }
  }, [dateRange]);


  useEffect(() => {
    monthlyBankBasedTotalAmountsReport();
  }, [bankBasedVolumeDate]);

  const getMonthlyPosVolumeReport = () => {
    RequestHandler.get("/PosTransactionReport/MonthlyValueReport").then(
      (response) => {
        setMonthlyPosVolumeData(response);
        setLoading(false);
      }
    );
  };


  const monthlyBankBasedTotalAmountsReport = () => {
    setLoadingMonthlyBankAmount(true);

    const requestData = {
      startDate: bankBasedVolumeDate.startMonth.startOf("month"),
      endDate: bankBasedVolumeDate.endMonth.endOf("month")
    };
    RequestHandler.post(
      `/PosTransactionReport/MonthlyBankBasedTotalAmountsReport`,
      requestData,
      false
    ).then((response) => {
      setMonthlyBankBasedTotalAmounts(response);
      setLoadingMonthlyBankAmount(false);
    });
  };

  const monthlyBankCommissionTotalsReport = () => {
    RequestHandler.get(
      "/PosTransactionReport/MonthlyBankCommissionTotalsReport"
    ).then((response) => {
      setMonthlyBankCommissionAmount(response);

      setMonthlyBankTotalCommissionAmount(response.reduce((sum,item) => sum + item.commissionAmount, 0));

      setloadingmonthlyBankBasedTotalAmountsReport(false);
    });
  };

  const usedPosReport = () => {
    RequestHandler.get("/PosTransactionReport/used-pos-report").then(
      (response) => {

        const formattedMostUsedPos = response.mostUsedPos.map((item) => ({
          ...item,
          bankAndTerminalName: `${item.bankName} (${item.terminalNumber})`,
        }));

        const formattedleastUsedPos = response.leastUsedPos.map((item) => ({
          ...item,
          bankAndTerminalName: `${item.bankName} (${item.terminalNumber})`,
        }));

        setMostMonthlyUsedPos(formattedMostUsedPos);
        setLeastMonthlyUsedPos(formattedleastUsedPos);
        setloadingMostMonthlyUsedPos(false);
        setloadingleastMonthlyUsedPos(false);
      }
    );
  }

  const forwardValueDateAmountReport = () => {

    setIsLoadingForwardValueDate(true);
    const requestData = {
      endDate: dateRange.endValorDate,
      startDate: dateRange.startValorDate,
      datePicker: dateRange.datePicture,
    };

    RequestHandler.post(
      `/PosTransactionReport/ForwardValueDateAmountReport`,
      requestData,
      false
    ).then((response) => {
      setForwardValueDateAmount(response);
      setIsLoadingForwardValueDate(false);
    });
  };

  function formatAmount(amount) {
    if(amount == undefined) {
      amount = 0;
    }

    const formattedAmount = new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 2,
    }).format(amount);

    return formattedAmount;
  }

  //#region  Ayın tarihini SubTitle alanına işler.
  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );


  function formatCustomDateRange(startDate, endDate) {
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    const startMonth = startDate.toLocaleString("default", { month: "long" });

    return `${startDay}-${endDay} ${startMonth}`;
  }
  //#endregion


  const handleDateRangeChange = (dates, type) => {

    if (dates && dates.length === 2) {
      const [newStartValorDate, newEndValorDate] = dates;

      if (newStartValorDate && newEndValorDate) {


        if(type === "valor") {

          const diffInDays = Math.abs(
            newEndValorDate.diff(newStartValorDate, "days")
          );

          if (diffInDays > 30) {
            notification.error({
              message: "Hata",
              description:
                "Başlangıç ve bitiş tarihleri arasındaki fark 30 günden fazla olamaz.",
            });
          } else {
            const startFormattedDate = newStartValorDate.format("YYYY.MM.DD");
            const endFormattedDate = newEndValorDate.format("YYYY.MM.DD");

            setDateRange({
              startValorDate: startFormattedDate,
              endValorDate: endFormattedDate,
              datePicture: true,
            });
          }
        }
        else if(type === "volume") {

          const diffInMonths = Math.abs(
            newEndValorDate.diff(newStartValorDate, "month")
          );
          if(diffInMonths >= 6) {
            notification.error({
              message: "Hata",
              description:
                "Başlangıç ve bitiş tarihleri arasındaki fark 6 aydan fazla olamaz.",
            });
            return;
          }

          setBankBasedVolumeDate({
            startMonth: newStartValorDate,
            endMonth:  newEndValorDate
          })
        }

      }
    }
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Row justify="space-between">
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(monthlyPosVolumeData.amount)}
            subTitle={formatCustomDateRange(firstDayOfMonth, lastDayOfMonth)}
            descText={<span style={{ color: "green" }}>TOPLAM TUTAR</span>}
          />
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(monthlyPosVolumeData.commissionAmount)}
            subTitle={formatCustomDateRange(firstDayOfMonth, lastDayOfMonth)}
            descText={<span style={{ color: "red" }}>KOMİSYON TUTARI</span>}
          />
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(monthlyPosVolumeData.netAmount)}
            subTitle={formatCustomDateRange(firstDayOfMonth, lastDayOfMonth)}
            descText={<span style={{ color: "green" }}>NET TUTAR</span>}
          />
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(monthlyPosVolumeData.returnAmount)}
            subTitle={formatCustomDateRange(firstDayOfMonth, lastDayOfMonth)}
            descText={
              <span style={{ color: "red" }}>İADE EDİLEN HESAP TUTARI</span>
            }
          />
          <IconWithTextCard
            icon="revenue-new"
            title={formatAmount(monthlyPosVolumeData.valueAmount)}
            subTitle={
              <span>
                {moment().format("DD MMMM")}
              </span>
            }
            impWidth="true"
            descText={
              <span style={{ color: "green" }}>
                 HESABA GEÇMESİ PLANLANAN VALÖR
              </span>
            }
          />
        </Row>

        <Row justify="center">
          <Col xs={24} md={12} lg={24}>
            <Card title="BANKA BAZLI HACİM" extra={
              <>

                <Form.Item name="bankaBazliValör" label="Tarih :">
                  <DatePicker.RangePicker
                    picker = "month"
                    format= "MMMM YYYY"
                    defaultValue={[bankBasedVolumeDate.startMonth, bankBasedVolumeDate.endMonth]}
                    onChange={(dates) => handleDateRangeChange(dates, "volume")}
                    value={[bankBasedVolumeDate.startMonth, bankBasedVolumeDate.endMonth]}
                  />
                </Form.Item>

              </>
            }>
              <PosMultiLinePlotChart
                data={monthlyBankBasedTotalAmounts}
                isLoading={loadingMonthlyBankAmount}
              />
            </Card>
          </Col>
        </Row>

        <Row justify="center">
          <Col xs={24} md={12} lg={24}>
            <Card title="BANKA BAZLI VALÖR" extra={<>

              <Form.Item name="bankaBazliValör" label="Tarih :">
                <DatePicker.RangePicker
                  format="DD.MM.YYYY"
                  defaultValue={[dateRange.startValorDate, dateRange.endValorDate]}
                  onChange={(dates) => handleDateRangeChange(dates, "valor")}
                  value={[dateRange.startValorDate, dateRange.endValorDate]}
                />
              </Form.Item>

            </>}>

              <PosGroupColumnChart
                data={forwardValueDateAmount}
                isLoading={isLoadingForwardValueDate}
              />
            </Card>
          </Col>
        </Row>

        <Row justify="center">
          <Col xs={24} sm={12} md={8} lg={8}>
            <Card title={<>
              Bankalara Göre Komisyon Tutarları  &nbsp;
              <Tooltip title="Son 1 aylık işlemlere göre veriler görüntülenmektedir.">
                <InfoCircleOutlined
                  style={{ color: "green", fontSize: "80%" }}
                />
              </Tooltip>
            </>} extra={<> Toplam: {formatAmount(monthlyBankTotalCommissionAmount)} </>} style={{ height: "550px" }}>

              <PosBarChart
                data={monthlyBankCommissionAmount}
                isLoading={loadingmonthlyBankBasedTotalAmountsReport}
                xField = "bankName"
                yField = "commissionAmount"
                label = "commissionAmount"
                isAmount = {true}
                showTooltip={true}
                toolTipName="Komisyon Tutarı"
                toolTipValue="commissionAmount"
                toolTipIsAmount={true}
              />
            </Card>
          </Col>

          <Col xs={24} sm={12} md={8} lg={8}>
            <Card title="En Çok Kullanılan Pos"  style={{ height: "550px" }}>

              <PosBarChart
                data={mostMonthlyUsedPos}
                isLoading={loadingMostMonthlyUsedPos}
                xField = "bankAndTerminalName"
                yField = "transactionCount"
                label = "transactionCount"
                showYTitle={true}
                showXTitle={true}
                yTitle = "Terminal Numarası"
                xTitle = "İşlem Sayısı"
                showTooltip={true}
                toolTipName="İşlem Adedi"
                toolTipValue="transactionCount"
              />

            </Card>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Card title="En Az Kullanılan Pos"  style={{ height: "550px" }}>

              <PosBarChart
                data={leastMonthlyUsedPos}
                isLoading={loadingleastMonthlyUsedPos}
                xField = "bankAndTerminalName"
                yField = "transactionCount"
                label = "transactionCount"
                showYTitle= {true}
                showXTitle ={true}
                yTitle = "Terminal Numarası"
                xTitle = "İşlem Sayısı"
                showTooltip={true}
                toolTipName="İşlem Adedi"
                toolTipValue="transactionCount"
              />
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

export default PosReports;
